module.exports = __webpack_public_path__ + "static/img/loader1.557336d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/loader1.gif
// module id = CsXN
// module chunks = 1